/* eslint-disable no-console */
import { createReducer, SUCCESS, updateObject } from 'Stores'
import { GET_PAYMENT } from './constants'

export const initialState = {
  type: null,
  getPayment: []
}

function getPaymentSuccess(state, { payload }) {
  const { getPayment } = payload
  return updateObject(state, {
    getPayment
  })
}

export default createReducer(initialState, {
  [SUCCESS(GET_PAYMENT)]: getPaymentSuccess
})
